export default {
  // 页面标题
  title: 'Coupon code',
  
  // 表单相关
  form: {
    title: 'Redeem your code',
    codePlaceholder: 'Enter your coupon code',
    codeRequired: 'Please enter your coupon code',
    submitButton: 'Redeem',
  },
  
  // 成功消息
  success: {
    title: 'Redeem Successful!',
  },
  
  // 优惠券列表
  couponList: {
    redemptionTime: 'Redemption Time:',
  },
  
  // 状态
  status: {
    active: 'Active',
    inactive: 'Inactive',
    pending: 'Pending',
    expired: 'Expired',
    used: 'Used',
    redeemed: 'Redeemed',
  },
};
